import * as firebaseApp from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/messaging'

import { get } from 'lodash'

export const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: `${process.env.VUE_APP_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${process.env.VUE_APP_PROJECT_ID}.firebaseio.com`,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: `${process.env.VUE_APP_PROJECT_ID}.appspot.com`,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID
}

export const firebase = firebaseApp
export const cloudUri = `gs://${process.env.VUE_APP_PROJECT_ID}.appspot.com/`

export const scrubUndefined = obj => {
  /**
   * @todo fix the usage. Make it return a new copy instead of modifying
   */
  /* eslint-disable no-param-reassign */
  return Object.keys(obj)
    .forEach(key => obj[key] === undefined && delete obj[key])
}

export const parseRef = docRef => {

  const parseSingleDocument = ref => {
    return ref && ref.exists
      ? { ...ref.data(), id: ref.id }
      : {}
  }

  const parseMultipleDocuments = ref => {
    return ref && ref.docs
      ? ref.docs.map(snap => parseSingleDocument(snap))
      : []
  }

  return docRef && docRef.docs
    ? parseMultipleDocuments(docRef)
    : parseSingleDocument(docRef)
}

// param for direction asc desc
export const sortByFirebaseTimestamp = (propertyPath, direction, a, b) => {
  const {
    seconds: aSeconds,
    nanoseconds: aNanoseconds
  } = get(a, propertyPath, {})

  const {
    seconds: bSeconds,
    nanoseconds: bNanoseconds
  } = get(b, propertyPath, {})

  const areSecondsEqual = () => aSeconds === bSeconds

  const compareSeconds = () => {
    return direction === 'desc'
      ? aSeconds > bSeconds ? -1 : 1
      : aSeconds < bSeconds ? -1 : 1
  }

  const compareNanoseconds = () => {
    return direction === 'desc'
      ? aNanoseconds > bNanoseconds ? -1 : 1
      : aNanoseconds < bNanoseconds ? -1 : 1
  }

  return areSecondsEqual()
    ? compareNanoseconds()
    : compareSeconds()

}
